<template>
  <v-app>
    <page-header />
    <main>
      <!-- <div v-if ="!$store.state.isUserLoggedIn">
      </div> -->
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </main>
    <page-footer />
  </v-app>
</template>

<script>
import PageHeader from '@/components/Header.vue'
import PageFooter from '@/components/Footer.vue'
export default {
  name: 'App',
  components: {
    PageHeader,
    PageFooter
  },
  data () {
    return {
      //
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/index.scss';

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #EEEEEE !important;
    color: #2c3e50;
    font-family: "Roboto" !important;
  }

  h1 {
    color: #757575;
  }


  #logo {
    margin-top: 300px;
    position: absolute;
    width: 40% !important;
  }

  a {
    text-decoration: none !important;
  }

  main {
    margin-top: 20px !important;
    height: 100% !important;
  }

  .card {
    padding: 15px 15px 15px 15px;
    border-radius: 1px !important;
    box-shadow: 5px 8px 5px #E0E0E0;
    background-color: white !important;
    font-family:'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }

  .v-toolbar {
    box-shadow: none !important;
  }

@media only screen and (min-width: 1264px) {
  .container {
      max-width: 100% !important;
  }
}
</style>

